'use es6';

import { Record } from 'immutable';
export default Record({
  completed: false,
  durationMinutes: undefined,
  id: undefined,
  mostRecentAttempt: undefined,
  name: undefined,
  language: undefined,
  passThreshold: undefined,
  length: undefined
}, 'Exam');